import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CbButtonControlDirective } from './button-control.directive';



@NgModule({
    declarations: [
        CbButtonControlDirective
    ],
    imports: [
        CommonModule
    ],
    exports: [
        CbButtonControlDirective
    ]
})
export class CbButtonControlModule { }
